import { IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { PropsWithChildren } from "react";

const useStyles = makeStyles({
    root: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        "& > h3": {
            fontSize: "20px",
            fontWeight: 600,
            color: "#4A4A4A",
            textAlign: "center",

            margin: 0,
        },
    },
    buttonSlot: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "48px",
        height: "48px",
        margin: "-24px -12px",

        "&:first-child": {
            marginRight: 0,
        },

        "&:last-child": {
            marginLeft: 0,
        },
    },
    closeIcon: {
        fontSize: "24px",
        color: "#4A4A4A",
    },
});

interface BlockingProgressItemHeaderProps {
    onClose: (() => void) | undefined;
}

export const BlockingProgressItemHeader = (props: PropsWithChildren<BlockingProgressItemHeaderProps>) => {
    const classes = useStyles();
    const { onClose, children } = props;

    return (
        <div className={classes.root}>
            <div className={classes.buttonSlot} />

            <h3>{children}</h3>

            <div className={classes.buttonSlot}>
                <IconButton aria-label="close" onClick={onClose}>
                    <CloseIcon className={classes.closeIcon} />
                </IconButton>
            </div>
        </div>
    );
};
